import mqtt from 'mqtt'
import base from '@/api/base.js';
export default class MQTTService {
    /**
     * 单例
     */
    static instance = null
    // 初始化websocket
    static get Instance () {
        if (!this.instance) {
            this.instance = new MQTTService()
        }
        return this.instance
    }

    // 和服务端连接的socket对象
    ws = null 
    // 存储回调函数
    callBackMapping = {}
    // 标识是否连接成功
    connected = false
    // 记录重试的次数
    sendRetryCount = 0
    //url
    initUrl = base.mqttWsServe;
    //心跳包定时执行的引用
    heartbeatTimeout = null
    //  定义连接服务器的方法
    connect (params) {
        // 连接服务器
        if (!window.WebSocket) {
            return console.log('您的浏览器不支持WebSocket')
        }
        // 连接字符串, 通过协议指定使用的连接方式
        // ws 未加密 WebSocket 连接
        // wss 加密 WebSocket 连接
        // mqtt 未加密 TCP 连接
        // mqtts 加密 TCP 连接
        // wxs 微信小程序连接
        // alis 支付宝小程序连接
        // 连接选项
        const  options = {
            clean: true, // true: 清除会话, false: 保留会话
            connectTimeout: 4000, // 超时时间
            // 认证信息
            clientId: params.clientId,
            username: '',
            password: '',
        }
        this.mqttWsClient = mqtt.connect(this.initUrl, options);

        this.mqttWsClient.on('connect',(connack)=>{
            console.log('连接成功:', connack)
            this.connected = true;
        })

        this.mqttWsClient.on('reconnect',(error)=>{
            console.log('正在重连:', error)
            this.connected = false;
        })

        this.mqttWsClient.on('error', (error) => {
            console.log('连接失败:', error)
            this.connected = false;
        })

        this.mqttWsClient.on('message', (topic, message) => {
            // console.log('收到消息：', topic, message.toString())
            // 真正服务端发送过来的原始数据时在msg中的data字段
            const recvData = JSON.parse(message.toString())
            // 判断回调函数是否存在
            if (this.callBackMapping[topic]) {
                this.callBackMapping[topic].call(this, recvData)
            }
        })
    }

    /**
     * 手动断开mqtt 关闭链接
     * @param {*} force 将其设置为true将立即关闭客户端，而无需等待正在运行的消息被打包。可选参数
     * @param {*} options reasonCode: 断开连接原因代码号  properties: {}
     * @param {*} callback 回调
     */
    end(force, options, callback){
        // 清空回调函数
        this.callBackMapping = {}
        this.mqttWsClient.end(force, options, callback)
    }
    /**
     * 订阅主题信息, 并设置回调函数
     * @param {*} topic 订阅主题
     * @param {*} callBack 主题收到消息后的回调函数
     */
    subscribeCallBack (topic, callBack) {
        console.log("topic---------", topic)
        this.mqttWsClient.subscribe(topic, {qos: 0}, function(err, granted){
            console.log("订阅消息内容", err, granted)
        });
        this.callBackMapping[topic] = callBack
    }

    /**
     * 订阅主题信息, 并设置回调函数
     * @param {*} topic 订阅主题
     * @param {*} options 订阅主题参数 ( qos, nl rap rh properties)
     * @param {*} callBack 主题收到消息后的回调函数
     */
    subscribeOptionsCallBack (topic, options = {qos: 1}, callBack) {
        this.mqttWsClient.subscribe(topic, options, function(err, granted){
            console.log("订阅消息内容", err, granted)
        });
        this.callBackMapping[topic] = callBack
    }

    // 取消某一个回调函数
    unSubscribeCallBack (topic) {
        this.mqttWsClient.unsubscribe(topic, {qos: 1}, function(err, granted){
            console.log("取消订阅消息内容", err, granted)
        });
        this.callBackMapping[topic] = null
    }


    // 发送数据的方法
    /**
     * 发送主题消息
     * @param {*} topic 消息主题
     * @param {*} message 消息内容
     * @param {*} options 参数配置 {qos, retain: 是否是保留消息 dup: 标记为重复标记 properties}
     * @param {*} callback 回调
     */
    publish(topic, message, options, callback) {
        // 判断此时此刻有没有连接成功
        if (this.connected) {
            this.sendRetryCount = 0;
            this.mqttWsClient.publish(topic, message, options, callback);
        } else {
            this.sendRetryCount++
            setTimeout(() => {
                this.send(topic, message, options, callback)
            }, this.sendRetryCount * 500)
        }
    }
}

